export default __webpack_public_path__ + "static/media/phone.d7c77550.svg";